import React from 'react';
import PropTypes from 'prop-types';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';
import { Link } from 'react-router-dom';
import MatchMedia from '../../../../components/match-media';

const CampaignLink = props => {
  const { campaign, linkContent, className, onClick } = props;

  if (!linkContent) {
    return null;
  }

  if (campaign.slug) {
    const qs = props.queryString || '';

    return (
      <Link
        className={className}
        to={`${campaign.web_uri.responsive}${qs}`}
        data-test={props['data-test']}
        onClick={onClick}
      >
        {linkContent}
      </Link>
    );
  }

  return (
    <MatchMedia
      debounce={150}
      serverSideRender={{ url: campaign.web_uri.desktop }}
      matches={[
        {
          mediaQuery: '(max-width: 640px)',
          values: { url: campaign.web_uri.mobile },
        },
        {
          mediaQuery: '(min-width: 640px)',
          values: { url: campaign.web_uri.desktop },
        },
      ]}
    >
      {({ url }) => (
        <a
          className={className}
          href={url}
          data-test={props['data-test']}
          onClick={onClick}
        >
          {linkContent}
        </a>
      )}
    </MatchMedia>
  );
};

const { shape, string, node, func } = PropTypes;

CampaignLink.propTypes = {
  linkContent: node,
  queryString: string,
  campaign: shape({
    title: shape({
      short: string,
    }),
    description: shape({
      short: string,
    }),
    web_uri: shape({
      desktop: string,
      mobile: string,
    }).isRequired,
  }).isRequired,
  className: string,
  'data-test': string,
  onClick: func,
};

CampaignLink.defaultProps = {
  linkContent: (
    <Button variant="outlined" color="primary">
      <T domain="campaigns">link.visit-campaign</T>
    </Button>
  ),
  className: null,
  queryString: null,
  'data-test': undefined,
  onClick: undefined,
};

export default CampaignLink;
